import type { ContactInfo } from '@rtkwlf/rendall';
import { parsePhoneNumber } from 'libphonenumber-js';

export const DEFAULT_PHONE_NUMBER = '+1 888 272 8429';
export const PHONE_KEY = '{{phoneNumber}}';
export const DEFAULT_EMAIL = 'security@arcticwolf.com';
export const EMAIL_KEY = '{{email}}';

export const formatPhoneNumber = (phoneNumber: string | undefined) => {
  let formattedNumber = phoneNumber;

  try {
    formattedNumber = phoneNumber
      ? parsePhoneNumber(phoneNumber).formatInternational()
      : phoneNumber;
  } catch {
    formattedNumber = phoneNumber;
  }

  return formattedNumber || '';
};

export const getFormattedPhoneNumber = (
  phoneNumber: string | undefined,
): string =>
  phoneNumber ? formatPhoneNumber(phoneNumber) : DEFAULT_PHONE_NUMBER;

export const getFormattedPhoneAndEmail = (
  inputString: string,
  contactInfo: ContactInfo | undefined,
): string =>
  inputString
    .replace(PHONE_KEY, getFormattedPhoneNumber(contactInfo?.phoneNumber))
    .replace(EMAIL_KEY, contactInfo?.email || DEFAULT_EMAIL);
